import { Box, Grid } from '@material-ui/core'
import moment from 'moment'
import { useSnackbar } from 'notistack'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { adminPlanOfferCodesByDateConstants } from '../../../../constants/formConstants/adminFormConstants'
import { totalOfferClaimHeadcells } from '../../../../constants/headCells/masterDataHeadCells'
import { getTotalCountByPlanId } from '../../../../services/giftingService'
import Button from '../../../commons/Button/Button'
import GenerateFormHook from '../../../commons/GenerateFormHook'
import Table from '../../../commons/Table/dataTable/Table'

const PlanOfferCodesByDate = ({
    plans = []
}) => {
    const [submitButtonIsLoading, setSubmitButtonIsLoading] = React.useState(false)
    const [tableData, setTableData] = React.useState([])
    const methods = useForm();
    const { enqueueSnackbar } = useSnackbar()
    const jwt = useSelector(state => state.auth.admin.jwt)


    const handleFormSubmit = async (data) => {
        if (!!data.fromDate && !!data.toDate) {
            data.fromDate = moment(data.fromDate).toDate().getTime()
            data.toDate = moment(data.toDate).toDate().getTime()
            console.log(data);
            setSubmitButtonIsLoading(true)

            const newTableData = []

            for (let i = 0; i < plans.length; i++) {
                const plan = plans[i];
                console.log(plan);

                const countResponse = await getTotalCountByPlanId({
                    ...data,
                    id: plan.plan_id,
                    jwt
                })
                if (countResponse) {
                    if (countResponse.payload) {
                        newTableData.push({
                            totalClaimed: countResponse.payload.find(count => count.is_paid === 1)?.total_sell,
                            name: plan.name,
                            brandName: plan.offer_brand_name
                        })
                    }
                }
            }
            if (newTableData.length === 0) {
                enqueueSnackbar('No data found!', {
                    variant: 'error'
                })
            }
            setSubmitButtonIsLoading(false)
            setTableData(newTableData)
        }
        else {
            enqueueSnackbar('Please choose a vaild date range!', {
                variant: 'error'
            })
        }

    }

    return (
        <>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(handleFormSubmit)}>
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <GenerateFormHook control={methods.control} formConstant={adminPlanOfferCodesByDateConstants()} />
                        </Grid>
                        <Grid item xs={8}>
                            <Box display='flex' alignItems='center' height={'100%'}>
                                <Button full variant='contained' type='submit' color='primary' isLoading={submitButtonIsLoading}>{!submitButtonIsLoading ? 'Search' : 'Searching...'}</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </FormProvider>
            <Table
                tableName='Offer Codes claimed by date'
                headCells={totalOfferClaimHeadcells}
                tableData={tableData}
                isLoading={submitButtonIsLoading}
                crud={{}}
                showDownloadButton
            />
        </>
    )
}

export default PlanOfferCodesByDate